

export default function NoMatch (){
    return <div className="flex justify-center items-center h-screen">
        <h1 className=" font-bold ">There are nothing in here</h1>
    </div>
}